import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { enrollStudent, getAllVerifiedStudent, deleteEnquiryById } from "../../services/getAdminApi";
import '../../styles/RegisterStudentList.css';
import { Delete, Edit } from '@mui/icons-material';

const TestResult = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [verifying, setVerifying] = useState({});
  const [sortOrder, setSortOrder] = useState("asc");

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const response = await getAllVerifiedStudent();
        if (response && response.data && Array.isArray(response.data.data)) {
          setStudents(response.data.data);
        } else {
          Swal.fire("Error", "Failed to fetch students data.", "error");
        }
      } catch (error) {
        console.error("Error fetching students:", error);
        Swal.fire("Error", "An error occurred while fetching the students.", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchStudents();
  }, []);

  const handleVerify = async (studentId) => {
    Swal.fire({
      title: "This can not be undone!",
      text: "Do you want to Enroll and notify this student?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Enroll!",
      cancelButtonText: "No, cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setVerifying((prev) => ({ ...prev, [studentId]: true }));
          await enrollStudent(studentId); // Calls the API
          setStudents((prevStudents) =>
            prevStudents.map((student) =>
              student.id === studentId ? { ...student, enrolled_students: 1 } : student
            )
          );
          Swal.fire("Enrolled!", "The student has been enrolled and notified.", "success");
        } catch (error) {
          Swal.fire("Error!", "An error occurred. Please try again.", "error");
        } finally {
          setVerifying((prev) => ({ ...prev, [studentId]: false }));
        }
      }
    });
  };

  const handleSort = () => {
    const sortedData = [...students].sort((a, b) => {
      const dateA = new Date(a.created_at);
      const dateB = new Date(b.created_at);
      return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
    });
    setStudents(sortedData);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  return (
    <div>
      <div className="dashboard-heading-div">
        <p>Test Results</p>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : students.length === 0 ? (
        <p>No students found.</p>
      ) : (
        <div className="table-container-registered-students">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Mobile</th>
                <th>Gender</th>
                <th>Nationality</th>
                <th>City</th>
                <th>Date & Time &nbsp;&nbsp;
                  <button onClick={handleSort}>
                    <i className='bx bxs-sort-alt' style={{ fontSize: "1rem" }}></i>
                  </button>
                </th>
                <th>Test Score</th>
                <th>Enrollment Status</th>
              </tr>
            </thead>
            <tbody>
              {students.map((student) => (
                <tr key={student.id}>
                  <td>{student.id}</td>
                  <td>{student.first_name}</td>
                  <td>{student.last_name}</td>
                  <td>{student.email}</td>
                  <td>{student.mobile}</td>
                  <td>{student.gender}</td>
                  <td>{student.nationality}</td>
                  <td>{student.city}</td>
                  <td>{new Date(student.created_at).toLocaleString()}</td>
                  <td>{student.score == null ? 'Test Pending' : student.score}</td>
                  <td>
                    {student.enrolled_students === 1 ? (
                      <button disabled style={{ backgroundColor: "#54d459" }} className="registed-student-verify">
                        Enrolled
                      </button>
                    ) : (
                      <button className="registed-student-verify"
                        onClick={() => handleVerify(student.id)}
                        disabled={verifying[student.id]}
                      >
                        {verifying[student.id] ? "Enrolling..." : "Enroll"}
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default TestResult;
